import script from "./carInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./carInfoList.vue?vue&type=script&setup=true&lang=js"

import "./carInfoList.vue?vue&type=style&index=0&id=60d45acb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d45acb"]])

export default __exports__